import { render, staticRenderFns } from "./LiveChip.vue?vue&type=template&id=455a4376&scoped=true"
var script = {}
import style0 from "./LiveChip.vue?vue&type=style&index=0&id=455a4376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a4376",
  null
  
)

export default component.exports